import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    boxShadow: '0px 3px 6px #00000014',
  },
  refreshButton: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 700,
    textTransform: 'Capitalize',
  },
  headerRoot: {
    alignItems: 'center',
    borderBottom: theme.palette.border.default,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 20px 0px 32px',
    minHeight: '48px',

    '& .MuiCardHeader-content': {
      '& .MuiCardHeader-title': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 500,
        textTransform: 'normal',
      },
    },

    '& .MuiCardHeader-action': {
      marginTop: 0,
      alignSelf: 'center',
    },
  },

  subheader: {
    backgroundColor: '#F9FCFF',
    padding: '24px 32px',
  },

  content: {
    maxHeight: 10000,
    padding: '24px 32px',
    transition: 'all 0.2s linear',
  },

  footer: {
    backgroundColor: '#F6F6F6',
    padding: '16px 32px',
  },

  actionButton: {
    marginTop: 8,
    marginRight: 18,
  },
  collapsed: {
    maxHeight: 0,
    opacity: 0,
    padding: '0 !important',
  },

  icon: {
    fontSize: 32,
    transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    transform: 'rotate(0deg)',
  },
  collapsedIcon: {
    transform: 'rotate(180deg)',
  },
}));

export default useStyles;
